import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ReactComponent as FileUploadIcon } from 'assets/icons/Screp.svg';
import clsx from 'clsx';
import Table from 'components/Table/Table';
import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableRow from 'components/Table/TableRow';
import formatFileUrl from 'utils/formatFileUrl';
import { getTextDate } from 'utils/formattedData';
import { getFileNameWithExtension } from 'utils/taskHelper';

import type ISelectMediaTable from './interfaces/IItemsTable';

import styles from './scss/ItemsTable.module.scss';

function ItemsTable({
  items,
  headCells,
  onLoadMore,
  hasMore,
  isInfoTable,
  handleGetDetails,
}: ISelectMediaTable) {
  const { t } = useTranslation();
  const hyphen = t('common.hyphen');

  return (
    <div className={styles.root}>
      <InfiniteScroll
        dataLength={items?.length || 0}
        next={onLoadMore}
        hasMore={hasMore}
        loader={false}
      >
        <div className={styles.tableBodyScroll}>
          <Table
            className={clsx(styles.table, {
              [styles.tableInfoTable]: isInfoTable,
            })}
          >
            <TableHead className={clsx(styles.header, {
              [styles.headerInfoTable]: isInfoTable,
            })}
            >
              {headCells.map(({
                id, label,
              }) => (
                <TableCell head className={styles.tableCell} key={id}>
                  <div>
                    <span className={styles.tableCellLabel}>
                      {t(label)}
                    </span>
                  </div>
                </TableCell>
              ))}
            </TableHead>
            <TableBody className={styles.body}>
              {items ? items?.map((item, index) => (
                <TableRow key={[item.id, index].join('_')} onClick={() => handleGetDetails(item.id)}>
                  <TableCell>
                    <div className={styles.staticCell}>
                      <span>{item?.respondent?.email || hyphen}</span>
                    </div>
                  </TableCell>
                  <TableCell>
                    {item.title || hyphen}
                  </TableCell>
                  <TableCell>
                    {getTextDate(item.createdAt) || hyphen}
                  </TableCell>
                  <TableCell>
                    {item.questionnaireType || hyphen}
                  </TableCell>
                  <TableCell>
                    <div className={styles.attachments}>
                      {item.attachments.map((attachment) => (
                        <a
                          key={[attachment?.id, attachment?.fileUrl].join('_')}
                          href={formatFileUrl(attachment?.fileUrl || '')}
                          className={styles.attachmentItem}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FileUploadIcon className={styles.attachmentIcon} />
                          {getFileNameWithExtension(attachment?.fileName || '', attachment?.fileUrl || '')}
                        </a>
                      ))}
                    </div>
                  </TableCell>
                </TableRow>
              )) : null}
            </TableBody>
          </Table>
        </div>
      </InfiniteScroll>
    </div>
  );
}

export default ItemsTable;
